import {fromJS} from 'immutable';
import newsActions from '../actions/news.actions';
import dieselReducer from 'epic-diesel-common/src/decorators/DieselReducer';

export const DEFAULT_STATE = fromJS({
    content: '',
    subtitle: '',
    faq: {},
    howItWorks: {}
});

export const newsReducer = (state = DEFAULT_STATE, action) => {
    let newState = state;
    switch (action.type) {
        case newsActions.TYPES.GET_NEWS_COMPLETE: {
            const {news, newsChildrens} = action.payload.news;
            newState = fromJS({
                news,
                newsChildrens
            });
            return newState;
        }
        default:
            return newState;
    }
};

export default dieselReducer('news', newsReducer);
